import { render, staticRenderFns } from "./ProjectPayment.vue?vue&type=template&id=3adc55fa&scoped=true&"
import script from "./ProjectPayment.vue?vue&type=script&lang=js&"
export * from "./ProjectPayment.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPayment.vue?vue&type=style&index=0&id=3adc55fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc55fa",
  null
  
)

component.options.__file = "ProjectPayment.vue"
export default component.exports